import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=119796d0&"
import script from "./CCard.vue?vue&type=script&lang=js&"
export * from "./CCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports